import { debounce } from "./debounce";
export function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof options === 'object') {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        leading: leading,
        maxWait: wait,
        trailing: trailing,
    });
}
